export const QUEST_TREASURE_SCROLL_STORAGE_KEY =
  "vocabularium_quest_treasure_scroll";

function readAll() {
  try {
    const raw = localStorage.getItem(QUEST_TREASURE_SCROLL_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function readQuestTreasureScroll(collectionId) {
  if (!collectionId) return 0;
  const value = readAll()[collectionId];
  return Number.isFinite(value) && value > 0 ? value : 0;
}

/** Vrai si une position a déjà été mémorisée pour cette collection (même 0). */
export function hasQuestTreasureScroll(collectionId) {
  if (!collectionId) return false;
  return Number.isFinite(readAll()[collectionId]);
}

export function writeQuestTreasureScroll(collectionId, scrollTop) {
  if (!collectionId) return;
  const value = Number.isFinite(scrollTop) && scrollTop > 0 ? Math.round(scrollTop) : 0;

  try {
    const all = readAll();
    all[collectionId] = value;
    localStorage.setItem(QUEST_TREASURE_SCROLL_STORAGE_KEY, JSON.stringify(all));
  } catch {
    // ignore quota / privacy mode errors
  }
}
